<ziro-top-nav></ziro-top-nav>
<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<div class="ziro-distribution-list-page-content">
  @if (!isLoading) {
    <div class="col-md-10 offset-md-1 top-buffer">
      <ziro-breadcrumbs></ziro-breadcrumbs>
      @if (columns) {
        <fieldset>
          <ziro-datatable
            [class]="'ziro-card'"
            [columns]="columns"
            [rowDataSource]="tableRows"
            [uniqueRowIdentifier]="'id'"
            [dataAutomation]="'distribution-list-datatable'"
            [mainFilterPlaceholder]="'tkey;pages.distributionlist.filter.placeholder' | translate"
          ></ziro-datatable>
        </fieldset>
      }
    </div>
  }
</div>
<ziro-bottom-nav></ziro-bottom-nav>
